var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isFetching ? _c('div', [_c('div', {
    staticClass: "t-loader"
  }, [_c('span', {
    staticClass: "loader-label"
  }, [_vm._v(" Fetching page "), _c('span', [_vm._v(_vm._s(_vm.pageNum))])]), _c('span', {
    staticClass: "loader-spinner"
  })])]) : _vm.imageSrc ? _c('div', [_c('Zoomable', {
    ref: "zoomable",
    attrs: {
      "containerHeight": _vm.viewerHeight,
      "containerWidth": _vm.viewerWidth,
      "contentHeight": _vm.contentHeight,
      "contentWidth": _vm.contentWidth
    }
  }, [_c('PageImage', {
    attrs: {
      "src": _vm.imageSrc,
      "width": _vm.contentWidth,
      "alt": "",
      "role": "presentation",
      "aria-hidden": "true"
    },
    on: {
      "loaded": _vm.loaded,
      "denied": _vm.denied
    }
  }), !_vm.offScreen ? _c('PageText', _vm._b({}, 'PageText', {
    extractedTextUrl: _vm.extractedTextUrl,
    pageNum: _vm.pageNum,
    searchTerms: _vm.searchTerms
  }, false)) : _vm._e(), !_vm.offScreen ? _c('div', [_vm._l(_vm.imageLinks, function (link, i) {
    return _vm._l(link.rectangleList, function (rect, j) {
      return _c('PageLink', _vm._b({
        key: "".concat(i, ".").concat(j),
        attrs: {
          "top": rect.top,
          "left": rect.left,
          "height": rect.height,
          "width": rect.width
        }
      }, 'PageLink', link, false));
    });
  })], 2) : _vm._e()], 1)], 1) : _c('div', [_vm._v("Unknown page type")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }